import React, { useState } from "react";
import { View, Alert } from "react-native";
import TextInputComponent from "../../components/textinput/TextInputComponent";
import Button from "../../components/button/Button";
import drawerHoc from "../../components/drawerHOC/DrawerHOC";
import Text from "../../components/text";
import Box from "../../components/box";
import ListCard from "../../components/listCard";
import { showSuccesToast } from "../tenants/tenantOnboarding/helpers";

const FinanceInsuranceQuote = ({ navigation }) => {
  const [state, setState] = useState({
    insurance_type: "",
    insurance_start_date: "",
    prev_premium: "",
    prev_company_name: "",
    landlord_name: "",
    landlord_address: "",
    phone: "",
    email: "",
    dob: "",
    property_address: "",
    property_postcode: "",
  });

  const [errors, setErrors] = useState({});

  const _handleChange = (value, label) => {
    setState({ ...state, [label]: value });
    setErrors({ ...errors, [label]: "" }); // clear error on typing
  };

  // ---------- VALIDATION ----------
  const validateFields = () => {
    let tempErrors = {};

    const requiredFields = {
      insurance_type: "Insurance Type is required",
      insurance_start_date: "Start Date is required",
      prev_premium: "Previous Premium is required",
      prev_company_name: "Company Name is required",
      landlord_name: "Landlord Name is required",
      landlord_address: "Landlord Address is required",
      phone: "Phone number is required",
      email: "Email is required",
      dob: "Date of Birth is required",
      property_address: "Property Address is required",
      property_postcode: "Post Code is required",
    };

    Object.keys(requiredFields).forEach((key) => {
      if (!state[key] || state[key].trim() === "") {
        tempErrors[key] = requiredFields[key];
      }
    });

    // Additional validation
    if (state.phone && state.phone.length < 7) {
      tempErrors.phone = "Enter valid phone number";
    }

    if (Object.keys(tempErrors).length > 0) {
      setErrors(tempErrors);
      return false;
    }

    return true;
  };

  const onPressQuote = () => {

    if (!validateFields()) {
      return;
    }else{
      showSuccesToast("Quote feature coming soon!");

    }
  };

  // Numeric + Amount helpers
  const numericOnly = (text) => text.replace(/[^0-9]/g, "");
  const amountOnly = (text) => text.replace(/[^0-9.]/g, "");

  return (
    <>
      <ListCard
        localUrlImage={require("./../../assets/images/finance.png")}
        title={"Finance"}
        description={"Please add the financial information relating to this property."}
      />

      <Box style={{ marginTop: 30 }}>
        <View style={{ justifyContent: "center", alignItems: "center" }}>
          <Text fontSize={20} bold marginBottom={20}>
            Property Insurance
          </Text>
        </View>

        {/* Insurance Type */}
        <TextInputComponent
          title={"Insurance Type"}
          value={state.insurance_type}
          onChangeText={(e) => _handleChange(e, "insurance_type")}
          error={errors.insurance_type}
        />

        {/* Insurance Start Date */}
        <TextInputComponent
          title={"Insurance Start Date"}
          isDate
          date={state.insurance_start_date}
          onChangeText={(e) => _handleChange(e, "insurance_start_date")}
          error={errors.insurance_start_date}
        />

        {/* Premium */}
        <TextInputComponent
          title={"Previous Premium Amount (Total)"}
          value={state.prev_premium}
          isAmount
          onChangeText={(e) => _handleChange(amountOnly(e), "prev_premium")}
          error={errors.prev_premium}
        />

        {/* Company Name */}
        <TextInputComponent
          title={"Previous Insurance Company Name"}
          value={state.prev_company_name}
          onChangeText={(e) => _handleChange(e, "prev_company_name")}
          error={errors.prev_company_name}
        />

        {/* PERSONAL INFO */}
        <View style={{ justifyContent: "center", alignItems: "center" }}>
          <Text fontSize={20} bold marginBottom={15}>
            Personal Information
          </Text>
        </View>

        <TextInputComponent
          title={"Landlord Name"}
          value={state.landlord_name}
          onChangeText={(e) => _handleChange(e, "landlord_name")}
          error={errors.landlord_name}
        />

        <TextInputComponent
          title={"Landlord Correspondence Address"}
          value={state.landlord_address}
          onChangeText={(e) => _handleChange(e, "landlord_address")}
          error={errors.landlord_address}
        />

        {/* Phone */}
        <TextInputComponent
          title={"Phone"}
          value={state.phone}
          isNumeric
          keyboardType="number-pad"
          onChangeText={(e) => _handleChange(numericOnly(e), "phone")}
          error={errors.phone}
        />

        {/* Email */}
        <TextInputComponent
          title={"Email"}
          value={state.email}
          onChangeText={(e) => _handleChange(e, "email")}
          error={errors.email}
        />

        {/* DOB */}
        <TextInputComponent
          title={"Date of Birth"}
          isDate
          date={state.dob}
          onChangeText={(e) => _handleChange(e, "dob")}
          error={errors.dob}
        />

        {/* Property Address */}
        <TextInputComponent
          title={"Property Address"}
          value={state.property_address}
          onChangeText={(e) => _handleChange(e, "property_address")}
          error={errors.property_address}
        />

        {/* Property Post Code */}
        <TextInputComponent
          title={"Property Post Code"}
          value={state.property_postcode}
          isNumeric
          keyboardType="number-pad"
          onChangeText={(e) => _handleChange(numericOnly(e), "property_postcode")}
          error={errors.property_postcode}
        />

        {/* Submit Button */}
        <Button
          type={"solid"}
          childText={"Request Quote"}
          onPress={onPressQuote}
          width={150}
          style={{ alignSelf: "center", marginTop: 20 }}
        />
      </Box>
    </>
  );
};

export default drawerHoc({
  Component: FinanceInsuranceQuote,
  showBackButton: true,
});
